export default {
  name: 'MaterialSymbolsSearchRounded'
};